import { Grid, TextField, Typography } from '@mui/material';
import CustomSelect from 'components/CustomSelect/customSelect';
import moment from 'moment';
import React, { useState } from 'react';
import {
  Control,
  Controller,
  FormState,
  UseFormHandleSubmit,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import { MailBoxFilterType } from 'types';

interface InterviewFilterFormProps {
  control: Control<MailBoxFilterType, any>;
  handleSubmit: UseFormHandleSubmit<MailBoxFilterType, undefined>;
  formState: FormState<MailBoxFilterType>;
  onSubmit: (data: MailBoxFilterType) => void;
  watch: UseFormWatch<MailBoxFilterType>;
  trigger: UseFormTrigger<MailBoxFilterType>;
  setParams: any;
}

export const MailboxFilterForm: React.FC<InterviewFilterFormProps> = ({
  control,
  handleSubmit,
  onSubmit,
  watch
}) => {
  const currentDate = moment().format('YYYY-MM-DD');
  const [fromDate, setFromDate] = useState<string | null>(null);
  const [toDate, setToDate] = useState<string | null>(null);

  return (
    <form className='private-form clientfilter-form' onSubmit={handleSubmit(onSubmit)}>
      <Grid container>
        <Grid item md={12} sm={12} xs={12} sx={{ width: '100%' }}>
          <Grid container sx={{ width: '100%' }}>
            <Grid item md={12} sm={12} xs={12} sx={{ width: '100%' }}>
              <Typography component={'div'} className='custom-field' sx={{ width: '100%' }}>
                <Typography component={'p'}>From Date</Typography>
                <Controller
                  control={control}
                  defaultValue={undefined}
                  name='fromDate'
                  render={({ field: { onChange, value } }) => {
                    return (
                      <TextField
                        id='date'
                        type='date'
                        value={value ? value : null}
                        className='clientfilter-time-from-to'
                        onChange={(e) => {
                          setFromDate(moment(e.target.value).format('YYYY-MM-DD'));
                          onChange(e);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          inputProps: { max: toDate ?? currentDate },
                        }}
                      />
                    );
                  }}
                />
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component={'div'} className='custom-field'>
                <Typography component={'p'}>To Date</Typography>
                <Controller
                  control={control}
                  defaultValue={undefined}
                  name='toDate'
                  render={({ field: { onChange, value } }) => {
                    return (
                      <TextField
                        id='date'
                        type='date'
                        className='clientfilter-time-from-to'
                        value={value ? value : null}
                        onChange={(e) => {
                          setToDate(moment(e.target.value).format('YYYY-MM-DD'));
                          onChange(e);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          inputProps: { min: fromDate, max: currentDate },
                        }}
                      />
                    );
                  }}
                />
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component={'div'} className='custom-field'>
                <Typography component={'p'}>Type</Typography>
                <Controller
                  control={control}
                  name='type'
                  defaultValue={undefined}
                  render={({ field: { onChange, value, name } }) => {
                    return (
                      <CustomSelect
                        labelKey={'label'}
                        valueKey={'value'}
                        options={[
                          { label: 'SendCv To Client', value: 'sendCvToClient' },
                          {
                            label: 'Interview Confirmation To Client',
                            value: 'interviewConfirmationToClient',
                          },
                          {
                            label: 'Interview Confirmation To Candidate',
                            value: 'interviewConfirmationToCandidate',
                          },
                        ]}
                        name={name}
                        isClearable={false}
                        value={value ? value : null}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        placeHolder='Select Type'
                      />
                    );
                  }}
                />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <button
        type='submit'
        className='clientfilter-form-btn'
        style={{
          ...(!(watch('fromDate') || watch('toDate') || watch('type'))
            ? { opacity: '0.5', cursor: 'not-allowed' }
            : {}),
        }}>
        Apply
      </button>
    </form>
  );
};
